import React, { lazy } from 'react';
import { PRODUCT_IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-129">
      <div className="max-w-7xl mx-auto text-center" data-id="element-130">
        <h1 className="text-4xl md:text-6xl font-extrabold text-blue-900 mb-6" data-id="element-131">
          Mega-Pack <span className="text-blue-600" data-id="element-132">Yoga</span> per Bambini
        </h1>
        <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-12" data-id="element-133">
          Il sistema completo che ti permette di preparare lezioni di yoga
          divertenti, sicure ed educative in pochi minuti — anche senza
          esperienza nell'insegnamento ai bambini.
        </p>

        {/* Product Images Fan */}
        <div className="relative h-[350px] md:h-[500px] mb-8 cursor-pointer group" onClick={scrollToOffer} data-id="element-134">
          {/* Tomo 2 */}
          <img src={PRODUCT_IMAGES.tomo2} alt="Giochi e Attività" className="absolute left-[2%] top-[18%] w-[18%] md:w-[20%] transform -rotate-12 shadow-2xl transition-all duration-300 group-hover:scale-105 group-hover:-translate-x-4" loading="lazy" data-id="element-135" />
          {/* Tomo 3 */}
          <img src={PRODUCT_IMAGES.tomo3} alt="Mindfulness ed Emozioni" className="absolute left-[16%] top-[8%] w-[18%] md:w-[20%] transform -rotate-6 shadow-2xl transition-all duration-300 group-hover:scale-105 group-hover:-translate-x-2" loading="lazy" data-id="element-136" />
          {/* Main Product */}
          <img src={PRODUCT_IMAGES.main} alt="Mega-Pack Yoga per Bambini" className="absolute left-1/2 top-[3%] w-[30%] transform -translate-x-1/2 shadow-2xl z-30 transition-all duration-300 group-hover:scale-110" data-id="element-137" />
          {/* Tomo 4 */}
          <img src={PRODUCT_IMAGES.tomo4} alt="Carte e Poster Posizioni" className="absolute right-[16%] top-[8%] w-[18%] md:w-[20%] transform rotate-6 shadow-2xl transition-all duration-300 group-hover:scale-105 group-hover:translate-x-2" loading="lazy" data-id="element-138" />
          {/* Tomo 5 */}
          <img src={PRODUCT_IMAGES.tomo5} alt="Famiglia e Scuola" className="absolute right-[2%] top-[18%] w-[18%] md:w-[20%] transform rotate-12 shadow-2xl transition-all duration-300 group-hover:scale-105 group-hover:translate-x-4" loading="lazy" data-id="element-139" />
        </div>

        <p className="text-lg font-semibold text-gray-700 mb-8" data-id="element-140">
          5 Risorse + 4 Bonus Gratuiti
        </p>

        <button onClick={scrollToOffer} className="bg-green-600 hover:bg-green-700 text-white font-bold text-xl py-5 px-10 rounded-full shadow-lg shadow-green-600/50 transition-all duration-300 animate-pulse" data-id="element-141">
          Accedi Ora al Mega-Pack
        </button>
      </div>
    </section>;
}